module.exports = __webpack_public_path__ + "img/2.65f915d3.png";